import { Gem, Home, TicketPercent, User, Utensils } from "lucide-react";

export interface NavItem {
  path: string;
  labelKey: string;
  icon: React.ElementType;
}

export const navItems: NavItem[] = [
  {
    path: "/home",
    labelKey: "nav.home",
    icon: Home,
  },
  {
    path: "/restaurant",
    labelKey: "nav.restaurant",
    icon: Utensils,
  },
  {
    path: "/loyalty",
    labelKey: "nav.loyalty",
    icon: Gem,
  },
  {
    path: "/vouchers",
    labelKey: "nav.voucher",
    icon: TicketPercent,
  },
  {
    path: "/profile",
    labelKey: "nav.profile",
    icon: User,
  },
];
